import { useEffect } from 'react';

const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Space+Mono:wght@400;700&display=swap');

  .sv-root { background: #F9F7F4; color: #1a1a1a; font-family: 'Space Mono', monospace; }

  /* ── HERO ── */
  .sv-hero {
    background: #FFF8EE; padding: 60px 40px 90px;
    position: relative; overflow: hidden;
    border-bottom: 1px solid #EDE8DE;
  }
  .sv-hero::before {
    content: ''; position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(27,47,232,0.07) 1px, transparent 1px);
    background-size: 28px 28px; pointer-events: none;
  }
  .sv-hero::after {
    content: ''; position: absolute; top: 0; right: 0; bottom: 0; width: 55%;
    background: radial-gradient(ellipse 70% 80% at 85% 45%, rgba(255,214,0,0.13) 0%, transparent 65%);
    pointer-events: none;
  }
  .sv-hero-inner { max-width: 1100px; margin: 0 auto; position: relative; z-index: 2; display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 60px; }
  .sv-hero-text { }

  /* ── HERO RIGHT VISUAL ── */
  .sv-hero-visual { position: relative; height: 420px; display: flex; align-items: center; justify-content: center; }
  .sv-vis-glow { position: absolute; width: 300px; height: 300px; border-radius: 50%; background: radial-gradient(circle, rgba(27,47,232,0.12) 0%, rgba(255,214,0,0.06) 50%, transparent 75%); animation: sv-glow-pulse 4s ease-in-out infinite; }
  @keyframes sv-glow-pulse { 0%,100%{transform:scale(1);opacity:0.8} 50%{transform:scale(1.15);opacity:1} }
  .sv-vis-ring-a { position: absolute; width: 320px; height: 320px; border-radius: 50%; border: 1.5px dashed rgba(27,47,232,0.18); animation: sv-spin-cw 28s linear infinite; }
  .sv-vis-ring-b { position: absolute; width: 210px; height: 210px; border-radius: 50%; border: 1.5px dashed rgba(255,214,0,0.3); animation: sv-spin-ccw 20s linear infinite; }
  @keyframes sv-spin-cw  { from{rotate:0deg}  to{rotate:360deg}  }
  @keyframes sv-spin-ccw { from{rotate:0deg}  to{rotate:-360deg} }
  .sv-vis-hub { position: absolute; width: 96px; height: 96px; border-radius: 50%; background: linear-gradient(135deg,#1B2FE8,#3355FF); display: flex; flex-direction: column; align-items: center; justify-content: center; box-shadow: 0 0 32px rgba(27,47,232,0.35), 0 0 64px rgba(27,47,232,0.12); animation: sv-hub-pulse 3s ease-in-out infinite; }
  @keyframes sv-hub-pulse { 0%,100%{box-shadow:0 0 32px rgba(27,47,232,0.35),0 0 64px rgba(27,47,232,0.12)} 50%{box-shadow:0 0 48px rgba(27,47,232,0.5),0 0 90px rgba(27,47,232,0.2)} }
  .sv-vis-hub-num { font-family:'Bebas Neue',monospace; font-size:30px; color:#fff; line-height:1; }
  .sv-vis-hub-lbl { font-family:'Space Mono',monospace; font-size:7px; font-weight:700; letter-spacing:0.15em; color:rgba(255,255,255,0.65); text-transform:uppercase; }
  /* Orbit wrappers — each rotates the full ring size, icon counter-rotates to stay upright */
  .sv-ow { position:absolute; width:320px; height:320px; top:50%; left:50%; margin:-160px 0 0 -160px; animation:sv-orb 22s linear infinite; }
  .sv-ow-0 { animation-delay:  0s;      }
  .sv-ow-1 { animation-delay: -3.67s;   }
  .sv-ow-2 { animation-delay: -7.33s;   }
  .sv-ow-3 { animation-delay: -11.0s;   }
  .sv-ow-4 { animation-delay: -14.67s;  }
  .sv-ow-5 { animation-delay: -18.33s;  }
  @keyframes sv-orb { from{rotate:0deg} to{rotate:360deg} }

  .sv-vis-icon { position:absolute; top:-23px; left:calc(50% - 23px); width:46px; height:46px; border-radius:12px; background:#fff; border:1.5px solid #E8E4DC; display:flex; align-items:center; justify-content:center; font-size:18px; box-shadow:0 6px 20px rgba(0,0,0,0.09); animation:sv-counter 22s linear infinite; }
  .sv-ow-0 .sv-vis-icon { animation-delay:  0s;     }
  .sv-ow-1 .sv-vis-icon { animation-delay: -3.67s;  }
  .sv-ow-2 .sv-vis-icon { animation-delay: -7.33s;  }
  .sv-ow-3 .sv-vis-icon { animation-delay: -11.0s;  }
  .sv-ow-4 .sv-vis-icon { animation-delay: -14.67s; }
  .sv-ow-5 .sv-vis-icon { animation-delay: -18.33s; }
  @keyframes sv-counter { from{rotate:0deg} to{rotate:-360deg} }
  .sv-vis-badge { position:absolute; background:#fff; border:1.5px solid #E8E4DC; border-radius:8px; padding:7px 12px; font-family:'Space Mono',monospace; font-size:9px; font-weight:700; color:#1a1a1a; letter-spacing:0.08em; white-space:nowrap; box-shadow:0 4px 14px rgba(0,0,0,0.06); }
  .sv-vis-badge b { color:#1B2FE8; }
  .sv-badge-1 { top:6%; right:4%; animation:sv-flt-up 4s ease-in-out infinite; }
  .sv-badge-2 { bottom:18%; left:1%; animation:sv-flt-dn 3.5s ease-in-out infinite 0.5s; }
  .sv-badge-3 { bottom:5%; right:8%; animation:sv-flt-up 3.8s ease-in-out infinite 1s; }

  @media(max-width:900px) { .sv-hero-inner { grid-template-columns:1fr; } .sv-hero-visual { display:none; } }
  .sv-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    border: 1px solid rgba(27,47,232,0.2); border-radius: 2px;
    font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700;
    letter-spacing: 0.25em; color: #1B2FE8; padding: 6px 16px; margin-bottom: 28px;
    text-transform: uppercase; background: rgba(27,47,232,0.04);
  }
  .sv-hero-title {
    font-family: 'Bebas Neue', monospace;
    font-size: clamp(60px,9vw,112px); line-height: 0.92;
    letter-spacing: 0.01em; color: #1a1a1a; margin-bottom: 28px;
  }
  .sv-hero-title em { color: #1B2FE8; font-style: normal; display: block; }

  /* ── Cycling word ── */
  .sv-cycle { position:relative; display:inline-block; color:#1B2FE8; font-style:normal; }
  .sv-cycle-spacer { visibility:hidden; display:block; }
  .sv-cycle-word { position:absolute; top:0; left:0; opacity:0; white-space:nowrap;
    animation: sv-cycle-anim 10s linear infinite; }
  .sv-cw-0{animation-delay:0s} .sv-cw-1{animation-delay:2s} .sv-cw-2{animation-delay:4s}
  .sv-cw-3{animation-delay:6s} .sv-cw-4{animation-delay:8s}
  @keyframes sv-cycle-anim {
    0%  {opacity:0;transform:translateY(14px)}
    6%  {opacity:1;transform:translateY(0)}
    18% {opacity:1;transform:translateY(0)}
    24% {opacity:0;transform:translateY(-14px)}
    100%{opacity:0}
  }
  .sv-hero-desc { font-family: 'Space Mono', monospace; font-size: 12px; line-height: 2; color: #888; max-width: 540px; letter-spacing: 0.06em; }

  /* ── MARQUEE ── */
  .sv-marquee-bar { background: #0E0E10; padding: 14px 0; overflow: hidden; white-space: nowrap; border-top: 1px solid rgba(255,214,0,0.12); border-bottom: 1px solid rgba(255,214,0,0.12); }
  .sv-marquee-track { display: inline-flex; animation: sv-mq 22s linear infinite; }
  .sv-marquee-item { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.22em; color: rgba(255,255,255,0.4); padding: 0 32px; display: flex; align-items: center; gap: 16px; text-transform: uppercase; transition: color 0.2s, text-shadow 0.2s; cursor: default; }
  .sv-marquee-item:hover { color: #FFD600; text-shadow: 0 0 10px rgba(255,214,0,0.9), 0 0 24px rgba(255,214,0,0.5); }
  .sv-mq-dot { display: inline-block; width: 4px; height: 4px; background: #FFD600; border-radius: 50%; flex-shrink: 0; }
  @keyframes sv-mq { from{transform:translateX(0)}to{transform:translateX(-50%)} }

  /* ── SERVICES GRID ── */
  .sv-grid-section { background: #F9F7F4; padding: 60px 40px; }
  .sv-grid-inner { max-width: 1100px; margin: 0 auto; }
  .sv-section-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: #999; margin-bottom: 16px; }
  .sv-section-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,68px); letter-spacing: 0.02em; color: #1a1a1a; margin-bottom: 36px; line-height: 1; }
  .sv-section-title em { color: #1B2FE8; font-style: normal; }
  .sv-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; }
  .sv-card { background: #F9F7F4; padding: 40px 32px; position: relative; transition: background 0.2s; }
  .sv-card:hover { background: #fff; }
  .sv-card-band { height: 3px; width: 40px; margin-bottom: 28px; }
  .sv-card-icon { font-size: 32px; margin-bottom: 20px; display: block; }
  .sv-card-title { font-family: 'Bebas Neue', monospace; font-size: 28px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 14px; line-height: 1.1; }
  .sv-card-desc { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 1.9; color: #888; margin-bottom: 24px; }
  .sv-card-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .sv-card-tag { font-family: 'Space Mono', monospace; font-size: 8px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; border: 1px solid #E8E4DC; padding: 4px 10px; color: #999; border-radius: 2px; }

  /* ── STATEMENT ── */
  .sv-statement {
    background: linear-gradient(160deg, #1C1C20 0%, #16161A 60%, #1A1620 100%);
    padding: 60px 40px; border-top: 1px solid rgba(255,214,0,0.1);
    position: relative; overflow: hidden;
  }
  .sv-statement::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 55% 50% at 70% 50%, rgba(255,214,0,0.07) 0%, transparent 70%);
    pointer-events: none;
  }
  .sv-statement::after {
    content: ''; position: absolute;
    top: 0; bottom: 0; left: -55%; width: 55%;
    background: linear-gradient(90deg, transparent 0%, rgba(255,214,0,0.05) 30%, rgba(27,47,232,0.07) 55%, rgba(255,214,0,0.05) 75%, transparent 100%);
    animation: sv-wave-pass 8s linear infinite;
    pointer-events: none; z-index: 0;
  }
  @keyframes sv-wave-pass { from{left:-55%} to{left:155%} }
  .sv-statement-inner { max-width: 900px; margin: 0 auto; position: relative; z-index: 1; }
  .sv-statement-text { font-family: 'Bebas Neue', monospace; font-size: clamp(48px,7vw,88px); line-height: 0.95; letter-spacing: 0.01em; color: #fff; text-transform: uppercase; margin-bottom: 28px; }
  .sv-statement-text em { color: #FFD600; font-style: normal; }
  .sv-statement-sub { font-family: 'Space Mono', monospace; font-size: 11px; line-height: 2; color: rgba(255,255,255,0.5); letter-spacing: 0.1em; max-width: 560px; }

  /* ── PROCESS ── */
  .sv-process-section { background: #fff; padding: 60px 40px; border-top: 1px solid #E8E4DC; }
  .sv-process-inner { max-width: 1100px; margin: 0 auto; }
  .sv-steps { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; margin-top: 64px; }
  .sv-step { background: #fff; padding: 36px 28px; }
  .sv-step-num { font-family: 'Bebas Neue', monospace; font-size: 48px; color: #E8E4DC; letter-spacing: 0.02em; line-height: 1; margin-bottom: 20px; }
  .sv-step-title { font-family: 'Bebas Neue', monospace; font-size: 22px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 10px; }
  .sv-step-desc { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 1.9; color: #999; }

  /* ── STATS ── */
  .sv-stats-section { background: #F9F7F4; padding: 80px 40px; border-top: 1px solid #E8E4DC; border-bottom: 1px solid #E8E4DC; }
  .sv-stats-inner { max-width: 960px; margin: 0 auto; display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; }
  .sv-stat { background: #F9F7F4; padding: 40px 28px; text-align: center; }
  .sv-stat-num { font-family: 'Bebas Neue', monospace; font-size: 56px; color: #1a1a1a; line-height: 1; margin-bottom: 8px; }
  .sv-stat-label { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase; color: #999; }

  /* REVEAL */
  .sv-reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .sv-reveal.visible { opacity: 1; transform: translateY(0); }

  @media (max-width:960px) {
    .sv-grid { grid-template-columns: repeat(2,1fr); }
    .sv-steps { grid-template-columns: repeat(2,1fr); }
    .sv-stats-inner { grid-template-columns: repeat(2,1fr); }
  }
  @media (max-width:600px) {
    .sv-grid { grid-template-columns: 1fr; }
    .sv-steps { grid-template-columns: 1fr; }
    .sv-stats-inner { grid-template-columns: 1fr 1fr; }
    .sv-grid-section, .sv-process-section, .sv-stats-section { padding-left: 20px; padding-right: 20px; }
  }
`;

function injectStyle(id, css) {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;
  const el = document.createElement('style');
  el.id = id; el.textContent = css;
  document.head.appendChild(el);
}

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.sv-reveal');
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.08 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

const MARQUEE = [
  'SEO & Growth', 'Paid Ads', 'Social Media', 'Content Strategy', 'Email Marketing', 'Web Analytics',
  'SEO & Growth', 'Paid Ads', 'Social Media', 'Content Strategy', 'Email Marketing', 'Web Analytics',
];

const SERVICES = [
  {
    icon: '🔍', band: '#1B2FE8', title: 'SEO & Organic Growth',
    desc: 'Rank higher, get found. We craft data-driven SEO strategies that drive consistent organic traffic and long-term visibility for your brand.',
    tags: ['Technical SEO', 'Keyword Research', 'Link Building', 'On-Page Optimisation'],
  },
  {
    icon: '📱', band: '#FFD600', title: 'Social Media Marketing',
    desc: 'Build a community, not just a following. We manage and grow your presence across Instagram, LinkedIn, Twitter/X and more.',
    tags: ['Content Creation', 'Community Management', 'Influencer Outreach', 'Analytics'],
  },
  {
    icon: '🎯', band: '#1a1a1a', title: 'Paid Advertising (PPC)',
    desc: 'Every rupee counts. We run precision-targeted Google, Meta and LinkedIn ad campaigns that deliver measurable ROI.',
    tags: ['Google Ads', 'Meta Ads', 'LinkedIn Ads', 'Retargeting'],
  },
  {
    icon: '✍️', band: '#1B2FE8', title: 'Content Marketing',
    desc: 'Words that convert. From blog posts to video scripts, we create content that educates your audience and builds authority.',
    tags: ['Blog Writing', 'Video Scripts', 'Case Studies', 'Whitepapers'],
  },
  {
    icon: '📧', band: '#FFD600', title: 'Email Marketing',
    desc: 'Your most direct channel. We design, write and automate email campaigns that nurture leads and drive repeat business.',
    tags: ['Campaign Design', 'Automation Flows', 'A/B Testing', 'Deliverability'],
  },
  {
    icon: '📊', band: '#1a1a1a', title: 'Analytics & Reporting',
    desc: 'Data without insight is noise. We set up dashboards, track KPIs and translate numbers into clear growth decisions.',
    tags: ['GA4 Setup', 'Custom Dashboards', 'Conversion Tracking', 'Monthly Reports'],
  },
];

const STEPS = [
  { num: '01', title: 'Discovery',   desc: 'We audit your current presence, understand your goals, and benchmark against competitors.' },
  { num: '02', title: 'Strategy',    desc: 'A bespoke roadmap tailored to your audience, budget and growth targets.' },
  { num: '03', title: 'Execution',   desc: 'Our specialists implement campaigns across every channel — on time, on brand.' },
  { num: '04', title: 'Optimise',    desc: 'Continuous testing and refinement to maximise performance month after month.' },
];

const STATS = [
  { num: '3.8×', label: 'Avg. ROI on Ad Spend' },
  { num: '180+', label: 'Brands Grown'          },
  { num: '94%',  label: 'Client Retention Rate' },
  { num: '12M+', label: 'Organic Impressions'   },
];

export default function Services() {
  useEffect(() => { injectStyle('sv-styles', STYLE); }, []);
  useReveal();

  return (
    <div className="sv-root">

      {/* HERO */}
      <section className="sv-hero">
        <div className="sv-hero-inner">
          <div className="sv-hero-text">
            <div className="sv-eyebrow sv-reveal">What We Offer</div>
            <h1 className="sv-hero-title sv-reveal">
              GROW YOUR<br />
              <span className="sv-cycle">
                <span className="sv-cycle-spacer">BUSINESS.</span>
                {['BRAND.','REVENUE.','TRAFFIC.','PRESENCE.','BUSINESS.'].map((w,i) => (
                  <span key={i} className={`sv-cycle-word sv-cw-${i}`}>{w}</span>
                ))}
              </span>
              <br />DOMINATE DIGITAL.
            </h1>
            <p className="sv-hero-desc sv-reveal">
              From search to social, paid ads to email — we deliver end-to-end digital
              marketing that turns clicks into customers and brands into category leaders.
            </p>
          </div>

          {/* Right animated visual */}
          <div className="sv-hero-visual">
            <div className="sv-vis-glow" />
            <div className="sv-vis-ring-a" />
            <div className="sv-vis-ring-b" />
            <div className="sv-vis-hub">
              <div className="sv-vis-hub-num">180+</div>
              <div className="sv-vis-hub-lbl">Brands</div>
            </div>
            <div className="sv-ow sv-ow-0"><div className="sv-vis-icon">🔍</div></div>
            <div className="sv-ow sv-ow-1"><div className="sv-vis-icon">📱</div></div>
            <div className="sv-ow sv-ow-2"><div className="sv-vis-icon">🎯</div></div>
            <div className="sv-ow sv-ow-3"><div className="sv-vis-icon">✍️</div></div>
            <div className="sv-ow sv-ow-4"><div className="sv-vis-icon">📧</div></div>
            <div className="sv-ow sv-ow-5"><div className="sv-vis-icon">📊</div></div>
            <div className="sv-vis-badge sv-badge-1"><b>3.8×</b> Avg ROI</div>
            <div className="sv-vis-badge sv-badge-2"><b>94%</b> Retention</div>
            <div className="sv-vis-badge sv-badge-3"><b>12M+</b> Impressions</div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="sv-marquee-bar">
        <div className="sv-marquee-track">
          {MARQUEE.map((item, i) => (
            <span key={i} className="sv-marquee-item">{item}<span className="sv-mq-dot" /></span>
          ))}
        </div>
      </div>

      {/* STATS */}
      <section className="sv-stats-section">
        <div className="sv-stats-inner sv-reveal">
          {STATS.map((s, i) => (
            <div className="sv-stat" key={i}>
              <div className="sv-stat-num">{s.num}</div>
              <div className="sv-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="sv-grid-section">
        <div className="sv-grid-inner">
          <p className="sv-section-eyebrow sv-reveal">Our Expertise</p>
          <h2 className="sv-section-title sv-reveal">Core <em>Services</em></h2>
          <div className="sv-grid sv-reveal">
            {SERVICES.map((s, i) => (
              <div className="sv-card" key={i}>
                <div className="sv-card-band" style={{ background: s.band }} />
                <span className="sv-card-icon">{s.icon}</span>
                <div className="sv-card-title">{s.title}</div>
                <p className="sv-card-desc">{s.desc}</p>
                <div className="sv-card-tags">
                  {s.tags.map((t, j) => <span key={j} className="sv-card-tag">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STATEMENT */}
      <section className="sv-statement">
        <div className="sv-statement-inner sv-reveal">
          <p className="sv-statement-text">
            RESULTS ARE NOT<br /><em>OPTIONAL.</em><br />THEY ARE THE STANDARD.
          </p>
          <p className="sv-statement-sub">
            Every campaign we run is tied to real business outcomes — leads, revenue, retention.
            We don't hide behind vanity metrics.
          </p>
        </div>
      </section>

      {/* PROCESS */}
      <section className="sv-process-section">
        <div className="sv-process-inner">
          <p className="sv-section-eyebrow sv-reveal">How We Work</p>
          <h2 className="sv-section-title sv-reveal">Our <em>Process</em></h2>
          <div className="sv-steps sv-reveal">
            {STEPS.map((s, i) => (
              <div className="sv-step" key={i}>
                <div className="sv-step-num">{s.num}</div>
                <h3 className="sv-step-title">{s.title}</h3>
                <p className="sv-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
